<div class="d-flex align-items-center justify-content-end">
  <div class="form-group btngroup-train mb-1">
    <ng-container>
      <button
        [disabled]="!saveEnabled"
        class="btn btn-primary updateBtn"
        type="button"
        (click)="UpdateTrain()"
        (keydown.enter)="UpdateTrain()"
      >
        Update
      </button>
    </ng-container>
  </div>

  <div class="form-group btngroup mb-1">
    <ng-container>
      @if (documentDetails?.status == "Created") {
        <button
          [disabled]="loading || !saveEnabled"
          class="btn btn-primary updateBtn"
          type="button"
          (click)="SaveNew()"
          (keydown.enter)="SaveNew()"
        >
          Save
        </button>
        <button
          [disabled]="loading"
          class="btn btn-primary updateBtn"
          type="button"
          (click)="changeStatus('submitted')"
          (keydown.enter)="changeStatus('submitted')"
        >
          Submit
        </button>
      }
    </ng-container>
  </div>
</div>

<div class="excel-wrapper">
  <div class="excel-file">
    @if (!isRepo) {
      <div class="add-row-bar">
        <button
          class="btn btn-outline-secondary btn-sm"
          type="button"
          (click)="addNewRow()"
          (keydown.enter)="addNewRow()"
        >
          <i class="bi bi-plus-circle"></i> Add Row
        </button>
      </div>
    }
    <div class="scrollable" (scroll)="onScroll($event)">
      @if (sheetData.length > 0) {
        <table class="excel-table-data">
          <thead>
            <tr>
              <th class="header s-no"></th>
              @for (header of headers; track trackByHeader($index, header)) {
                <th class="header">
                  {{ header }}
                </th>
              }
              <!-- keeping for delete implementation in future -->
              @if (false) {
                <span>
                  @if (documentDetails?.status === "Created") {
                    <th class="header delete-col"></th>
                  }
                </span>
              }
            </tr>
          </thead>
          <tbody>
            @if (currentSheetName && data) {
              @for (row of sheetData; track $index; let i = $index) {
                <tr>
                  <td class="s-no">{{ i + 1 }}</td>
                  @for (cell of sheetColumn; track $index; let j = $index) {
                    <td
                      [ngClass]="{
                        active:
                          editcell[0] == i && editcell[1] == j && editEnabled,
                      }"
                    >
                      @if (
                        editcell[0] == i && editcell[1] == j && editEnabled
                      ) {
                        <span class="edit-wrapper">
                          @if (isRepo) {
                            <div
                              [id]="'input-' + i + '-' + j"
                              contenteditable="true"
                              [ngClass]="{
                                'cell-locked':
                                  activeFields.question_field == headers[j],
                              }"
                              (keydown)="onLockedKeydown($event, i, j)"
                              (paste)="onLockedPaste($event, i, j)"
                              (blur)="onRepoEditBlur($event, i, j)"
                              (input)="onRepoEditInput()"
                              [innerHTML]="row[cell]"
                              style="
                                min-height: 40px;
                                outline: none;
                                white-space: pre-wrap;
                                word-break: break-word;
                              "
                            ></div>
                          }
                          @if (!isRepo) {
                            <textarea
                              [innerHTML]="row[cell]"
                              (input)="onInputChange($event, i, j)"
                              #textArea
                            ></textarea>
                          }
                        </span>
                        <span class="edit-train-btn">
                          @if (
                            activeFields.question_field == headers[j] &&
                            this.documentDetails?.status === "Created"
                          ) {
                            <div class="checkbox-wrapper-toggle">
                              <input
                                class="tgl tgl-ios"
                                id="toggle-edit-{{ id }}-{{ i }}-{{ j }}"
                                type="checkbox"
                                [checked]="ischecked(i, j, currentSheetName)"
                                (change)="
                                  toggle(
                                    $event,
                                    i,
                                    j,
                                    row[cell],
                                    currentSheetName,
                                    data
                                  )
                                "
                              />
                              <label
                                class="tgl-btn"
                                for="toggle-edit-{{ id }}-{{ i }}-{{ j }}"
                                aria-label="Answer from AI"
                              ></label>
                              <span>Answer from AI</span>
                            </div>
                          }
                        </span>
                      } @else {
                        <div
                          [id]="'input-' + i + '-' + j"
                          (blur)="onDataChanges($event, i, j)"
                          (focus)="selectCell(i, j)"
                          [contentEditable]="editable"
                          [innerHTML]="row[cell]"
                        ></div>
                        @if (activeFields.starting_row <= i + 1) {
                          @if (
                            isRepo &&
                            activeFields.question_field == headers[j] &&
                            !(
                              editcell[0] == i &&
                              editcell[1] == j &&
                              editEnabled
                            ) &&
                            documentDetails?.status !== "Created"
                          ) {
                            <div class="checkbox-wrapper-toggle">
                              <input
                                class="tgl tgl-ios"
                                [id]="
                                  'toggle-nonEdit-' + id + '-' + i + '-' + j
                                "
                                type="checkbox"
                                [checked]="ischecked(i, j, currentSheetName)"
                                (keydown.enter)="
                                  toggle(
                                    $event,
                                    i,
                                    j,
                                    row[cell],
                                    currentSheetName,
                                    data
                                  )
                                "
                                (keydown.space)="
                                  toggle(
                                    $event,
                                    i,
                                    j,
                                    row[cell],
                                    currentSheetName,
                                    data
                                  )
                                "
                                (click)="
                                  toggle(
                                    $event,
                                    i,
                                    j,
                                    row[cell],
                                    currentSheetName,
                                    data
                                  )
                                "
                                (keydown.enter)="
                                  toggle(
                                    $event,
                                    i,
                                    j,
                                    row[cell],
                                    currentSheetName,
                                    data
                                  )
                                "
                              />
                              <label
                                class="tgl-btn"
                                [for]="
                                  'toggle-nonEdit-' + id + '-' + i + '-' + j
                                "
                                aria-label="Answer from AI"
                              ></label>
                              <span>Answer from AI</span>
                            </div>
                          }
                          <div class="created-edit">
                            @if (
                              !readOnly &&
                              activeFields.question_field == headers[j] &&
                              (!isRepo || row[cell]?.trim())
                            ) {
                              <span class="d-flex justify-content-end px-2">
                                <span class="icons">
                                  <span
                                    class="icon"
                                    (click)="enableEdit(i, j)"
                                    (keydown.enter)="enableEdit(i, j)"
                                  >
                                    <i class="bi bi-pencil-square"></i>
                                  </span>
                                </span>
                              </span>
                            }
                            @if (!isRepo || isRepo) {
                              @if (
                                !readOnly &&
                                activeFields.answer_field == headers[j] &&
                                (!isRepo || (isRepo && row[cell]?.trim()))
                              ) {
                                <span class="d-flex justify-content-end px-2">
                                  <span class="icons">
                                    <span
                                      class="icon"
                                      (click)="enableEdit(i, j)"
                                      (keydown.enter)="enableEdit(i, j)"
                                      (keydown.space)="enableEdit(i, j)"
                                      title="Enter your answer"
                                    >
                                      <i class="bi bi-pencil-square"></i>
                                    </span>
                                  </span>
                                </span>
                              }
                              @if (
                                activeFields.comments_field == headers[j] &&
                                (!isRepo || row[cell]?.trim())
                              ) {
                                <span class="d-flex justify-content-end px-2">
                                  <span class="icons">
                                    <span
                                      class="icon"
                                      (click)="enableEdit(i, j)"
                                      (keydown.enter)="enableEdit(i, j)"
                                      (keydown.space)="enableEdit(i, j)"
                                    >
                                      <i class="bi bi-pencil-square"></i>
                                    </span>
                                  </span>
                                </span>
                              }
                              @if (
                                activeFields.attachment_field == headers[j] &&
                                (!isRepo || row[cell]?.trim())
                              ) {
                                <span class="d-flex justify-content-end px-2">
                                  <span class="icons">
                                    <span
                                      class="icon"
                                      (click)="enableEdit(i, j)"
                                      (keydown.enter)="enableEdit(i, j)"
                                      (keydown.space)="enableEdit(i, j)"
                                    >
                                      <i class="bi bi-pencil-square"></i>
                                    </span>
                                  </span>
                                </span>
                              }
                            }
                          </div>
                        }
                      }
                    </td>
                  }
                  <!-- future implementation for delete -->
                  @if (false) {
                    <td
                      class="delete-col"
                      (click)="deleteRow(i)"
                      (keydown.enter)="deleteRow(i)"
                      (keydown.space)="deleteRow(i)"
                      title="Delete row"
                    >
                      <i
                        class="bi bi-trash text-danger"
                        style="cursor: pointer"
                      ></i>
                    </td>
                  }
                </tr>
              }
            }
          </tbody>
        </table>
      }
    </div>

    @if (sheetData.length === 0 && !loading) {
      <div class="empty-data">Empty Sheet</div>
    }

    <div class="footer">
      Sheets:
      @for (sheet of sheetNames; track sheet) {
        <div
          class="sheet"
          [ngClass]="{ active: currentSheetName == sheet }"
          (click)="setSelectedSheetName(sheet)"
          (keydown.enter)="setSelectedSheetName(sheet)"
          (keydown.space)="setSelectedSheetName(sheet)"
        >
          {{ sheet }}
        </div>
      }
    </div>

    @if (loading) {
      <div class="loading">
        <div class="spinner">
          <div class="lds-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
